<template>
  <LoaderOverlay :active="!post" />

  <main class="pt-24" v-if="post">
    <div class="container mx-auto sm:px-4 mt-[-9rem] rounded-[2.4rem] pt-48">
      <ArticlesPagination
        :categorySlug="'blog'"
        :category="$t('articles')"
        :title="post.title"
      />
      <!-- <ArticlesHeroSection
      v-if="posts.length > 0"
      :category="'Blog'"
      :categorySlug="'blog'"
      :title="post.title"
      :bannerImage="post.bannerImage"
      :doctorImage="post.authorImage"
      :doctorName="post.authorName"
      :postName="post.title"
    /> -->

      <!-- <div v-for="(section, index) in sections" :key="index" class="pb-[50px] md:pb-[12rem]"> -->
      <TextImageSection
        class="md:pt-14"
        :title="post.title"
        :description="post.text"
        :imageSrc="post.image"
        :imageAlt="post.title"
        :useAlternateLayout="true"
      />
      <!-- </div> -->

      <RelatedPostSection
        :relatedPosts="relatedPosts"
        :category="post.category"
      />
    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";
// import ArticlesHeroSection from "@/components/blog/articlesHeroSection.vue";
import TextImageSection from "@/components/blog/textImageSection/textImageSection.vue";
import RelatedPostSection from "@/components/blog/relatedPostSection.vue";
import ArticlesPagination from "@/components/blog/articlesPagination.vue";
import LoaderOverlay from "@/components/loader/loader.vue";
import { blogService } from "@/services/blogService.ts";
import { config } from "@/services/configService.ts";

import drImage from "@/assets/images/articles-dr-enrique.png";
import blogFallback from "@/assets/images/articles-bannar-image1.png";
import { setSeo, jsonLd } from "@/composables/useSeo";

export default defineComponent({
  name: "BlogPostView",
  components: {
    // ArticlesHeroSection,
    TextImageSection,
    RelatedPostSection,
    ArticlesPagination,
    LoaderOverlay,
  },
  data() {
    return {
      post: null,
      relatedPosts: [],
      fallbackPost: null,
      fallbackRelatedPosts: [],
    };
  },
  async mounted() {
    const postId = this.$route.params.id;
    if (postId) {
      await this.loadPostDetails(postId);
      await this.loadRelatedPosts(postId);
    }
  },
  methods: {
    async loadPostDetails(id) {
      const apiPost = await blogService.getPostById(id);

      if (!apiPost) {
        this.post = {
          ...this.getFallbackPost(),
          id,
        };
        return;
      }

      this.post = {
        id: apiPost.id,
        title: apiPost.title,
        text: apiPost.text || this.$t("Content currently unavailable."),
        image: `${config.host}${config.uploads}${apiPost.image}`,
        category: apiPost.category,
      };

      const excerpt = (apiPost.text || "").replace(/<[^>]+>/g, "").slice(0, 155).trim();
      setSeo({
        title: apiPost.title,
        description: excerpt || apiPost.title,
        image: this.post.image,
        type: "article",
        jsonLd: jsonLd.blogArticle({
          title: apiPost.title,
          description: excerpt,
          image: this.post.image,
          url: window.location.href,
        }),
      });
    },

    async loadRelatedPosts(currentPostId) {
      let apiPosts = await blogService.getPopularPosts();

      apiPosts = (apiPosts || []).filter((p) => p.id != currentPostId);

      if (!apiPosts.length) {
        this.relatedPosts = this.getFallbackRelatedPosts();
        return;
      }

      this.relatedPosts = apiPosts.map((post) => ({
        id: post.id,
        title: post.title,
        authorName: this.$t("Medkus Team"),
        authorImage: drImage,
        image: `${config.host}${config.uploads}${post.image}`,
        alt: this.$t("Cover image for {postTitle}", { postTitle: post.title }),
        category: "blog",
      }));
    },
    // resolveImage(rawImage) {
    //   if (rawImage === null || rawImage === undefined) {
    //     return blogFallback;
    //   }

    //   const resolved = resolveMediaUrl(rawImage);
    //   if (resolved) {
    //     return resolved;
    //   }

    //   if (typeof rawImage === "string" && rawImage.trim()) {
    //     return rawImage;
    //   }

    //   return blogFallback;
    // },
    getFallbackPost() {
      return {
        id: "blog-fallback-1",
        title: this.$t("Content temporarily unavailable"),
        text: this.$t(
          "We are restoring the connection to our blog. Thank you for your patience."
        ),
        image: blogFallback,
      };
    },
    getFallbackRelatedPosts() {
      return [
        {
          id: "blog-fallback-related-1",
          title: this.$t("We will be back with more articles soon"),
          authorName: this.$t("Medkus Team"),
          authorImage: drImage,
          image: blogFallback,
          alt: this.$t("Temporary article placeholder"),
          category: "blog",
        },
      ];
    },
  },
});
</script>

<style scoped></style>
